import React from "react";
import cx from "classnames";
import styles from "./Breadcrumb.module.scss";
import Icons from "@gstyles/styleguide/icons";
import Link from "@components/Link";
import renderPropsComposer from "@utils/renderPropsComposer";
import _ from "lodash";

export default function Breadcrumb({ data, mode = "light", className }: any) {
  if (_.isEmpty(data)) return null;
  return (
    <div
      data-scroll-section
      className={cx(styles.breadcrumb, className, {
        [styles.dark]: mode === "dark",
      })}
    >
      {_.map(data, (item, index) => {
        const last = _.isEqual(data.length - 1, index);
        return renderPropsComposer(
          {
            matcher: (item: any) => _.isEqual(_.get(item, "type"), "text"),
            render: (item: any) => (
              <React.Fragment key={`breadcrumb_${index}`}>
                {_.get(item, "name")}
                {!last && (
                  <Icons
                    name="chevron-right-outline"
                    size={14}
                    color="#898084"
                  />
                )}
              </React.Fragment>
            ),
          },
          {
            matcher: (item: any) => _.isEqual(_.get(item, "type"), "link"),
            render: ({ to, ...item }: any) => {
              return (
                <React.Fragment key={`breadcrumb_${index}`}>
                  <Link href={_.isFunction(to) ? to() : to} {...item}>
                    {_.get(item, "name")}
                  </Link>
                  {!last && (
                    <Icons
                      name="chevron-right-outline"
                      size={14}
                      color="#898084"
                    />
                  )}
                </React.Fragment>
              );
            },
          },
          {
            matcher: "default",
            render: (item: any) => (
              <React.Fragment key={`breadcrumb_${index}`}>
                {_.get(item, "name")}
                {!last && (
                  <Icons
                    name="chevron-right-outline"
                    size={14}
                    color="#898084"
                  />
                )}
              </React.Fragment>
            ),
          }
        )(item);
      })}
    </div>
  );
}
